import { Injectable } from '@angular/core'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';

import { AuthenticationService } from '../auth/authentication.service';

import { Observable } from 'rxjs';

@Injectable()
export class DefaultRequestOptions implements HttpInterceptor {

    constructor(
        private authService: AuthenticationService) { }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Get the auth header
        const authHeader = this.authService.authorisationHeader;
        if (authHeader && req.url.indexOf("amazonaws.com") == -1 && req.url.indexOf("googleapis.com") == -1) {
            // Clone the request to add the new header.
            const authReq = req.clone({ setHeaders: { 'Authorization': authHeader } });

            // Pass on the cloned request instead of the original request.
            return next.handle(authReq);
        } else {
            // No header, return the original request headers
            return next.handle(req);
        }
    }
}